module.exports = __webpack_public_path__ + "img/logo-2.dd5ff6f4.png";